import { signOut } from 'firebase/auth';
import { auth } from '../firebase/client';

/** Ends the current Firebase web session (same behavior as the shell Sign out control). */
export function signOutApp(): Promise<void> {
    return signOut(auth);
}
